import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { TokenService } from '../token.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private token = inject(TokenService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    //  const token = this.token.get();
    const sesame = this.token.getSesame();
    // const interceptToken = token ?? sesame;
    if (sesame && this.shouldSendToken(request)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${sesame}`,
        },
      });
    }
    // if (sesame && this.shouldSendSesameToken(request)) {
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${sesame}`,
    //     },
    //   });
    // }
    return next.handle(request);
  }

  private shouldSendToken(request: HttpRequest<unknown>): boolean {
    return (
      request.url.startsWith(environment.api) && !request.url.endsWith('/login')
    );
  }
  // private shouldSendSesameToken(request: HttpRequest<unknown>): boolean {
  //   return request.url.startsWith(environment.telescope);
  // }
}
